export default __webpack_public_path__ + "static/media/seed.2a492824.svg";